interface checkStateConditionsForSpp {
  (state: any, isFutureProduct: boolean): boolean;
}

// Get group number from form state
export const getGroupNumber = (name: string) => {
  return +name.split('.')[0]?.replace(/[^0-9]/g, '');
};

// Get the values we need from the date to avoid changes depending on utc
export const getStringFromDate = (date: string) => {
  return date.split('T')[0];
};

// Check condition for render schedule ccm update for ccm services
export const checkConditionsForCcmButton = (state, hiddenForGroup: boolean) => {
  const requiredFields = [
    'products--DIAB--isEnabled',
    'products--DIABP--isEnabled',
    'products--HYPT--isEnabled',
    'products--MYSTRPLUS--isEnabled',
    'products--WEIGM--isEnabled'
  ];
  return requiredFields.some((field) => state[field]) && !hiddenForGroup;
};

// Get object keys with an specific string we need
export const getFieldsKeys = (fields: any, string: string) => Object.keys(fields).filter((key) => key.includes(string));

// Get product code
export const getCode = (key: string) => key.split('--')[1];

// Check conditions for enabling Single price point checkbox in both form and modal
export const checkStateConditionsForSpp: checkStateConditionsForSpp = (state, isFutureProduct) => {
  let requiredFields = [];
  if (isFutureProduct) {
    requiredFields = [
      'futureProductsCCM--DIAB--bundleType',
      'futureProductsCCM--DIABP--bundleType',
      'futureProductsCCM--HYPT--bundleType',
      'futureProductsCCM--DIAB--isEnabled',
      'futureProductsCCM--DIABP--isEnabled',
      'futureProductsCCM--HYPT--isEnabled'
    ];
  } else {
    requiredFields = [
      'products--DIAB--bundleType',
      'products--DIABP--bundleType',
      'products--HYPT--bundleType',
      'products--DIAB--isEnabled',
      'products--DIABP--isEnabled',
      'products--HYPT--isEnabled'
    ];
  }

  return requiredFields.every((field) => {
    if (field.includes('bundleType')) {
      return state[field] === 'PLUS';
    } else if (field.includes('isEnabled')) {
      return state[field] === true;
    }
    return false;
  });
};

// Label for ccm modal
export const getCcmLabel = (product: string) => {
  let label: string;

  switch (product) {
    case 'DIAB':
      label = 'Diabetes';
      break;
    case 'DIABP':
      label = 'Pre-diabetes';
      break;
    case 'HYPT':
      label = 'Hypertension';
      break;
    case 'MYSTRPLUS':
      label = 'myStrength Plus';
      break;
    case 'WEIGM':
      label = 'Weight management';
      break;
    case 'SPP':
      label = 'Single price point';
      break;
    default:
      label = 'Invalid Code';
      break;
  }
  return label;
};

export const hasProductChange = (state, modal) => {
  return (
    state['futureProductsCCM--DIAB--bundleType'] !== modal['futureProductsCCM--DIAB--bundleType'] ||
    state['futureProductsCCM--HYPT--bundleType'] !== modal['futureProductsCCM--HYPT--bundleType'] ||
    state['futureProductsCCM--DIABP--bundleType'] !== modal['futureProductsCCM--DIABP--bundleType'] ||
    state['futureProductsCCM--DIAB--isEnabled'] !== modal['futureProductsCCM--DIAB--isEnabled'] ||
    state['futureProductsCCM--HYPT--isEnabled'] !== modal['futureProductsCCM--HYPT--isEnabled'] ||
    state['futureProductsCCM--DIABP--isEnabled'] !== modal['futureProductsCCM--DIABP--isEnabled'] ||
    state['futureProductsCCM--WEIGM--isEnabled'] !== modal['futureProductsCCM--WEIGM--isEnabled'] ||
    state['futureProductsCCM--MYSTRPLUS--isEnabled'] !== modal['futureProductsCCM--MYSTRPLUS--isEnabled'] ||
    state['futureProductsCCM--SPP--isEnabled'] !== modal['futureProductsCCM--SPP--isEnabled']
  );
};
